import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface Theme {
    // palette: {
    //   pageBackground: string
    // }
  }
  // allow configuration using `createTheme()`
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface ThemeOptions {
    // status?: {
    //   danger?: string
    // }
    // palette: {
    //   pageBackground: string
    // }
  }
  interface PaletteColor {
    light: string
    main: string
    dark: string
    contrastText: string
    50: string
    100: string
    200: string
    300: string
    400: string
    500: string
    600: string
    700: string
    800: string
    900: string
    A100: string
    A200: string
    A400: string
    A700: string
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    pageBackground: string
  }
  interface PaletteOptions {
    pageBackground: string
    pdfBackground: string
  }
  interface BreakpointOverrides {
    widescreen: true
  }
}

// theme generator
// https://m2.material.io/inline-tools/color/

export const theme = createTheme({
  palette: {
    text: {
      primary: '#263628',
      secondary: '#435445',
    },
    primary: {
      '50': '#def4f8',
      '100': '#aee4ed',
      '200': '#7bd3e0',
      '300': '#47c1d3',
      '400': '#22b5ca',
      '500': '#02a9c1',
      '600': '#039aaf',
      '700': '#038596',
      '800': '#04727e',
      '900': '#055054',
      main: '#04727e',
    },
    secondary: {
      '50': '#fff2df',
      '100': '#ffdeb0',
      '200': '#ffc87c',
      '300': '#ffb148',
      '400': '#ff9f1e',
      '500': '#ff8e00',
      '600': '#ff8200',
      '700': '#fe7100',
      '800': '#f85f00',
      '900': '#ef3f04',
      main: '#ffc87c',
    },
    pageBackground: '#fafbff',
    pdfBackground: '#e7e7e7',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      widescreen: 1900,
    },
  },
})
